import React from 'react';

const Icon = () => {
    return (
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M50 25C50 38.81 38.8075 50 25 50C11.1925 50 0 38.81 0 25C0 11.195 11.1925 0 25 0C38.8075 0 50 11.195 50 25Z" fill="#24C277" />
            <path d="M22.0314 33.1202C21.4714 33.1202 20.9114 32.9077 20.4839 32.4802L14.5514 26.5477C13.6964 25.6927 13.6964 24.3077 14.5514 23.4552C15.4064 22.6002 16.7889 22.5977 17.6439 23.4527L22.0314 27.8402L32.3514 17.5202C33.2064 16.6652 34.5889 16.6652 35.4439 17.5202C36.2989 18.3752 36.2989 19.7602 35.4439 20.6152L23.5789 32.4802C23.1514 32.9077 22.5914 33.1202 22.0314 33.1202Z" fill="white" />
        </svg>
    );
};

export default Icon;


